module.exports = __webpack_public_path__ + "media/application/images/icons/download-arrow-f406daddea0838c3eae5e6a305fd47a3.svg";